import QuestMenu from './Quiz';

export default QuestMenu;
